/** Draw control room routes (outcome agent, §16.2). `draws` replaces the shell placeholder. */
import type { ConsoleRoute } from '../index';
import { DrawRoomPage } from './DrawRoomPage';
import { DrawsListPage } from './DrawsListPage';

export const drawsRoutes: ConsoleRoute[] = [
  {
    path: 'draws',
    handle: {
      permission: ['draw.precheck', 'draw.run', 'draw.reveal', 'draw.audit.read'],
      title: 'Draw control room',
    },
    element: <DrawsListPage />,
  },
  {
    path: 'draws/:drawId',
    handle: {
      permission: ['draw.precheck', 'draw.run', 'draw.reveal', 'draw.audit.read'],
      title: 'Draw room',
    },
    element: <DrawRoomPage />,
  },
];
